export default "__VITE_ASSET__DEKdWjkq__"